function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var PeerService = require('saito-js/lib/peer_service')["default"];
var Transaction = require('../../lib/saito/transaction')["default"];
var saito = require('./../../lib/saito/saito');
var ModTemplate = require('../../lib/templates/modtemplate');
var SaitoHeader = require('./../../lib/saito/ui/saito-header/saito-header');
var BuySaitoHome = require('./index');
var SaitoPurchaseOverlay = require('./lib/saito-purchase');
var EXCLUDED_PAYMENT_TICKERS = new Set(['ERC-SAITO', 'BEP-SAITO']);
function isAvailablePaymentCurrency(currency) {
  return Boolean(currency === null || currency === void 0 ? void 0 : currency.ticker) && !EXCLUDED_PAYMENT_TICKERS.has(currency.ticker);
}

//
//
var BuySaito = /*#__PURE__*/function (_ModTemplate) {
  function BuySaito(app) {
    var _this;
    _classCallCheck(this, BuySaito);
    _this = _callSuper(this, BuySaito, [app]);
    _this.name = 'BuySaito';
    _this.slug = 'buy';
    _this.dbname = 'buysaito';
    _this.dependencies = ['Relay', 'Mixin', 'ERC'];
    _this.description = 'Buy native SAITO';
    _this.categories = 'Utility Ecommerce NFTs';
    _this.status = 'prod';
    _this["class"] = 'utility';
    _this.social = _this.buildSocial({
      twitter: '@SaitoOfficial',
      title: '🟥 Official SAITO Sales Platform',
      url: '/buysaito/',
      description: 'Get SAITO',
      image: 'https://saito.tech/wp-content/uploads/2022/04/saito_card_horizontal.png'
    });
    _this.mixin_mod = null;
    _this.erc_saito = null;
    _this.time_limit = 25 * 60000;
    // For the full node, to juggle multiple deposit addresses
    _this.mixin_accounts = [];

    /* A list of payments to handle
       stored in a DB every time a status is updated and restored on load for 
       persistence across server down time
     */
    _this.pending_payments = [];
    _this.authorized_public_key = 'cNACSaLdZQfbPkTTud4ezLWFYqRPUCMEt2dgLxJ9Axxx';
    _this.available_currencies = [];
    _this.service_ready = false;
    _this.processing_payments = false;
    _this.payment_poll_timer = null;

    // turn this on to fake receiving a mixin payment and test out the UX flow
    _this.local_dev = false;
    _this.purchase_overlay = new SaitoPurchaseOverlay(app, _this);
    _this.styles = ['/buy/style.css'];
    return _this;
  }
  _inherits(BuySaito, _ModTemplate);
  return _createClass(BuySaito, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app) {
        var _this2 = this;
        var _app$options, _app$options2, _app$options3, _app$options4, _app$options5, _app$options6;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _superPropGet(BuySaito, "initialize", this, 3)([app]);
            case 1:
              if (app.BROWSER) {
                this.attachStyleSheets();
              }
              if (this.app.BROWSER) {
                _context2.n = 3;
                break;
              }
              _context2.n = 2;
              return this.ensurePurchasesSchema();
            case 2:
              this.mixin_mod = app.modules.returnModule('Mixin');
              if (((_app$options = app.options) === null || _app$options === void 0 || (_app$options = _app$options.server) === null || _app$options === void 0 || (_app$options = _app$options.endpoint) === null || _app$options === void 0 ? void 0 : _app$options.host) == 'localhost' || ((_app$options2 = app.options) === null || _app$options2 === void 0 || (_app$options2 = _app$options2.server) === null || _app$options2 === void 0 || (_app$options2 = _app$options2.endpoint) === null || _app$options2 === void 0 ? void 0 : _app$options2.host) == 'ksaito.hda0.net' || (_app$options3 = app.options) !== null && _app$options3 !== void 0 && (_app$options3 = _app$options3.server) !== null && _app$options3 !== void 0 && (_app$options3 = _app$options3.endpoint) !== null && _app$options3 !== void 0 && _app$options3.host.includes('staging') || (_app$options4 = app.options) !== null && _app$options4 !== void 0 && (_app$options4 = _app$options4.server) !== null && _app$options4 !== void 0 && (_app$options4 = _app$options4.endpoint) !== null && _app$options4 !== void 0 && _app$options4.host.includes('testnet') || (_app$options5 = app.options) !== null && _app$options5 !== void 0 && (_app$options5 = _app$options5.server) !== null && _app$options5 !== void 0 && (_app$options5 = _app$options5.endpoint) !== null && _app$options5 !== void 0 && _app$options5.host.includes('test') || (_app$options6 = app.options) !== null && _app$options6 !== void 0 && (_app$options6 = _app$options6.server) !== null && _app$options6 !== void 0 && _app$options6.host.includes('staging')) {
                this.authorized_public_key = this.publicKey;
              } else {
                this.local_dev = false;
              }
              setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                var account, _t;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.p = _context.n) {
                    case 0:
                      _context.p = 0;
                      if (!(_this2.mixin_mod && _this2.authorized_public_key === _this2.publicKey)) {
                        _context.n = 6;
                        break;
                      }
                      _context.n = 1;
                      return _this2.mixin_mod.createAccount();
                    case 1:
                      account = _context.v;
                      if (!(account !== null && account !== void 0 && account.err || !_this2.mixin_mod.account_created)) {
                        _context.n = 2;
                        break;
                      }
                      console.error('BUYSAITO disabled: unable to initialize Mixin account', account === null || account === void 0 ? void 0 : account.err);
                      return _context.a(2);
                    case 2:
                      _context.n = 3;
                      return _this2.loadAltAccounts();
                    case 3:
                      _context.n = 4;
                      return _this2.loadPendingPayments();
                    case 4:
                      _context.n = 5;
                      return _this2.checkPrices();
                    case 5:
                      _this2.service_ready = true;
                      _this2.startPaymentPolling();
                      _context.n = 7;
                      break;
                    case 6:
                      if (_this2.authorized_public_key === _this2.publicKey) {
                        console.warn('BUYSAITO disabled: Mixin module is not available');
                      }
                    case 7:
                      _context.n = 9;
                      break;
                    case 8:
                      _context.p = 8;
                      _t = _context.v;
                      console.error('BUYSAITO disabled: initialization failed', _t);
                    case 9:
                      return _context.a(2);
                  }
                }, _callee, null, [[0, 8]]);
              })), 2000);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "returnServices",
    value: function returnServices() {
      var services = [];
      if (!this.app.BROWSER) {
        if (this.publicKey == this.authorized_public_key) {
          services.push(new PeerService(null, 'buysaito'));
        }
      }
      return services;
    }
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app, peer) {
        var service,
          _args3 = arguments;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              service = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
              //
              // If our direct peer is the BuySaito service provider,
              // make sure we update the publickey we send requests to
              //
              if (service.service === 'buysaito') {
                this.authorized_public_key = peer.publicKey;
              }
              if (this.browser_active && ['relay', 'buysaito'].includes(service.service)) {
                this.app.connection.emit('relay-send-message', {
                  recipient: this.authorized_public_key,
                  request: 'buysaito available currencies',
                  data: null
                });
              }
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function onPeerServiceUp(_x2, _x3) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!(!this.app.BROWSER || !this.browser_active)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              if (this.header) {
                _context4.n = 3;
                break;
              }
              this.header = new SaitoHeader(this.app, this);
              _context4.n = 2;
              return this.header.initialize(this.app);
            case 2:
              this.header.header_class = 'arcade';
              this.addComponent(this.header);
            case 3:
              _context4.n = 4;
              return _superPropGet(BuySaito, "render", this, 3)([]);
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      if (this.browser_active) {
        this.purchase_overlay.renderAmountPage();
      }
    }

    //
    // All communication between browser and service node are off chain, using Relay
    // commands are "bidirectional", i.e. server response uses the same request name
    //
    // *** buysaito available currencies -- request/receive list of acceptable web3 cryptos
    // *** buysaito reserve address -- request/receive a dedicated deposit address for a particular web3 crypto and expected deposit amount
    // *** buysaito release address -- inform server that we don't need the reserved deposit address
    // *** buysaito saito issued -- inform browser of purchase success (on top of also propagating the desired tx)
    //
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(app) {
        var tx,
          peer,
          mycallback,
          txmsg,
          _this$erc_saito,
          i,
          data,
          payment,
          j,
          _args5 = arguments,
          _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              tx = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : null;
              peer = _args5.length > 2 ? _args5[2] : undefined;
              mycallback = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : null;
              if (!(tx == null)) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2, 0);
            case 1:
              txmsg = tx.returnMessage();
              if (tx.isTo(this.publicKey)) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2, 0);
            case 2:
              if (!(typeof (txmsg === null || txmsg === void 0 ? void 0 : txmsg.request) === 'string' && txmsg.request.includes('buysaito'))) {
                _context5.n = 16;
                break;
              }
              console.debug(txmsg);
              if (txmsg.request == 'buysaito available currencies') {
                if (this.publicKey === this.authorized_public_key && !this.app.BROWSER) {
                  if (this.service_ready && !this.available_currencies.length) {
                    this.loadAvailableCryptos();
                  }
                  this.app.connection.emit('relay-send-message', {
                    recipient: tx.from[0].publicKey,
                    request: 'buysaito available currencies',
                    data: {
                      ac: this.service_ready ? this.available_currencies : null,
                      erc: (_this$erc_saito = this.erc_saito) === null || _this$erc_saito === void 0 ? void 0 : _this$erc_saito.price_usd
                    }
                  });
                  this.hasPendingPayment(tx.from[0].publicKey);
                } else if (txmsg.data && this.app.BROWSER) {
                  this.available_currencies = Array.isArray(txmsg.data.ac) ? txmsg.data.ac.filter(isAvailablePaymentCurrency) : null;
                  if (!this.erc_saito) {
                    this.erc_saito = {
                      price_usd: txmsg.data.erc
                    };
                  }
                  if (this.browser_active) this.purchase_overlay.renderAmountPage();
                  this.app.connection.emit('saito-purchase-cryptos');
                } else {
                  console.warn("BUYSAITO - We are getting a request we shouldn't be...");
                  // console.warn(txmsg);
                }
              }
              if (txmsg.request === 'buysaito report error') {
                if (tx.isFrom(this.authorized_public_key) && this.app.BROWSER) {
                  this.app.connection.emit('saito-purchase-error-notification', txmsg.data || {});
                }
              }
              if (!(txmsg.request === 'buysaito reserve address')) {
                _context5.n = 11;
                break;
              }
              if (!(this.publicKey === this.authorized_public_key && !this.app.BROWSER)) {
                _context5.n = 10;
                break;
              }
              _context5.p = 3;
              if (this.service_ready) {
                _context5.n = 4;
                break;
              }
              throw new Error('BuySaito Mixin service is not initialized');
            case 4:
              if (!(!txmsg.data || !tx.isFrom(txmsg.data.initiator_pubkey))) {
                _context5.n = 5;
                break;
              }
              throw new Error('Public key mismatch in payment instruction request');
            case 5:
              if (this.hasPendingPayment(tx.from[0].publicKey, txmsg.data.ticker)) {
                _context5.n = 7;
                break;
              }
              _context5.n = 6;
              return this.checkPrices();
            case 6:
              _context5.n = 7;
              return this.findAvailableAddress(txmsg.data);
            case 7:
              _context5.n = 9;
              break;
            case 8:
              _context5.p = 8;
              _t2 = _context5.v;
              this.reportPaymentInstructionError(tx.from[0].publicKey, _t2);
            case 9:
              _context5.n = 11;
              break;
            case 10:
              if (tx.isFrom(this.authorized_public_key) && this.app.BROWSER) {
                this.pending_payments.push(txmsg.data);
                this.app.connection.emit('saito-purchase-address-reserved', txmsg.data);
              } else {
                console.warn("BUYSAITO - We are getting a request we shouldn't be...");
                // console.warn(txmsg);
              }
            case 11:
              if (txmsg.request === 'buysaito release address') {
                if (this.publicKey === this.authorized_public_key && !this.app.BROWSER) {
                  for (i = 0; i < this.pending_payments.length; i++) {
                    if (this.pending_payments[i].initiator_pubkey == tx.from[0].publicKey && this.pending_payments[i].ticker == txmsg.data.ticker) {
                      this.pending_payments[i].status = 'cancelled';
                      this.cancelPayment(this.pending_payments[i].id);
                    }
                  }
                } else {
                  console.warn("BUYSAITO - We are getting a request we shouldn't be...");
                  // console.warn(txmsg);
                }
              }
              if (txmsg.request === 'buysaito payment detected') {
                if (this.app.BROWSER && tx.isFrom(this.authorized_public_key)) {
                  data = txmsg.data;
                  payment = this.pending_payments.find(function (p) {
                    return p.id === (data === null || data === void 0 ? void 0 : data.id) && p.destination === (data === null || data === void 0 ? void 0 : data.destination) && p.ticker === (data === null || data === void 0 ? void 0 : data.ticker);
                  });
                  if (payment && ['pending', 'confirmed'].includes(data.status)) {
                    payment.status = data.status;
                    this.app.connection.emit('saito-purchase-payment-detected', data);
                  }
                }
              }
              if (!(txmsg.request === 'buysaito saito issued')) {
                _context5.n = 15;
                break;
              }
              if (!(tx.isFrom(this.authorized_public_key) && this.app.BROWSER)) {
                _context5.n = 15;
                break;
              }
              j = 0;
            case 12:
              if (!(j < this.pending_payments.length)) {
                _context5.n = 14;
                break;
              }
              if (!(this.pending_payments[j].destination == txmsg.data.destination)) {
                _context5.n = 13;
                break;
              }
              this.pending_payments.splice(j, 1);
              this.app.connection.emit('saito-purchase-saito-issued', txmsg.data);
              return _context5.a(2);
            case 13:
              j++;
              _context5.n = 12;
              break;
            case 14:
              console.warn('BUYSAITO - received notification for an Unexpected pending payment');
              _context5.n = 15;
              break;
            case 15:
              return _context5.a(2, 0);
            case 16:
              return _context5.a(2, _superPropGet(BuySaito, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
          }
        }, _callee5, this, [[3, 8]]);
      }));
      function handlePeerTransaction(_x4) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
    /**
     * Confirm payouts on-chain and also refresh deposits when a block arrives.
     * The independent timer keeps deposit detection running between blocks.
     */
  }, {
    key: "onNewBlock",
    value: function () {
      var _onNewBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(blk, lc) {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (!(this.service_ready && this.publicKey == this.authorized_public_key && !this.app.BROWSER)) {
                _context6.n = 2;
                break;
              }
              _context6.n = 1;
              return this.confirmIssuedPaymentsInBlock(blk, lc);
            case 1:
              _context6.n = 2;
              return this.processPendingPayments();
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function onNewBlock(_x5, _x6) {
        return _onNewBlock.apply(this, arguments);
      }
      return onNewBlock;
    }()
  }, {
    key: "startPaymentPolling",
    value: function startPaymentPolling() {
      var _this3 = this,
        _this$payment_poll_ti,
        _this$payment_poll_ti2;
      if (this.payment_poll_timer || !this.service_ready || this.app.BROWSER || this.publicKey !== this.authorized_public_key) {
        return;
      }
      this.payment_poll_timer = setInterval(function () {
        _this3.processPendingPayments()["catch"](function (err) {
          console.error('BUYSAITO - Payment polling failed:', err.message);
        });
      }, 10000);
      (_this$payment_poll_ti = (_this$payment_poll_ti2 = this.payment_poll_timer).unref) === null || _this$payment_poll_ti === void 0 || _this$payment_poll_ti.call(_this$payment_poll_ti2);
    }
  }, {
    key: "destroy",
    value: function destroy(app) {
      clearInterval(this.payment_poll_timer);
      this.payment_poll_timer = null;
      _superPropGet(BuySaito, "destroy", this, 3)([app]);
    }
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var webdir = "".concat(__dirname, "/../../mods/").concat(this.dirname, "/web");
      var buysaito_self = this;
      expressapp.get('/' + encodeURI(this.returnSlug()), /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(req, res) {
          var reqBaseURL, updatedSocial, html;
          return _regenerator().w(function (_context7) {
            while (1) switch (_context7.n) {
              case 0:
                reqBaseURL = req.protocol + '://' + req.headers.host + '/';
                updatedSocial = Object.assign({}, buysaito_self.social);
                html = BuySaitoHome(app, buysaito_self, app.build_number, updatedSocial);
                if (res.finished) {
                  _context7.n = 1;
                  break;
                }
                res.setHeader('Content-type', 'text/html');
                res.charset = 'UTF-8';
                return _context7.a(2, res.send(html));
              case 1:
                return _context7.a(2);
            }
          }, _callee7);
        }));
        return function (_x7, _x8) {
          return _ref2.apply(this, arguments);
        };
      }());
      expressapp.use('/' + encodeURI(this.returnSlug()), express["static"](webdir));
    }

    //////////////////////////
    /// SERVER FUNCTIONS
    //////////////////////////
  }, {
    key: "reportPaymentInstructionError",
    value: function reportPaymentInstructionError(publicKey) {
      var err = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      console.error('BUYSAITO - Unable to generate payment instructions:', err);
      this.app.connection.emit('relay-send-message', {
        recipient: publicKey,
        request: 'buysaito report error',
        data: {
          message: 'The payment service could not generate a deposit address. Please try again shortly.'
        }
      });
    }

    // Use the current Mixin USD-pair rates plus a 5% spread to calculate a given SAITO value
    // in a web3 Crypto. Rounds up to 6th decimal place
    // To-do: round up to 6 significant digit
    //
  }, {
    key: "convertSaitoToOther",
    value: function convertSaitoToOther(amount) {
      var ticker = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      console.log('Currency Conversion: ', amount, ticker);
      var saito_price = this.erc_saito ? 1.1 * Number(this.erc_saito.price_usd) : 1;

      // Make sure we don't sell for less than 1/10 penny
      saito_price = Math.max(0.001, saito_price);
      var usd_price = 0;
      if (ticker) {
        var _this$mixin_mod;
        var currencies = ((_this$mixin_mod = this.mixin_mod) === null || _this$mixin_mod === void 0 ? void 0 : _this$mixin_mod.crypto_mods) || this.available_currencies || [];
        var _iterator = _createForOfIteratorHelper(currencies),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var cm = _step.value;
            if (cm.ticker == ticker) {
              usd_price = Number(cm.price_usd);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      if (usd_price == 0) {
        console.warn('BUYSAITO - No ticker selected for conversion!');
      }

      // calculate
      var amount_to_deposit = amount * saito_price / usd_price;

      //restrict to 6 significant digits
      amount_to_deposit = Math.ceil(amount_to_deposit * 1000000) / 1000000;

      // Mixin truncates TRX to 6 digits, send 0.32758538, but received amount: '0.327585',

      return amount_to_deposit;
    }
  }, {
    key: "convertToSaito",
    value: function convertToSaito(amount) {
      var ticker = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var saito_price = this.erc_saito ? 1.1 * Number(this.erc_saito.price_usd) : 1;

      // Make sure we don't sell for less than 1/10 penny
      saito_price = Math.max(0.001, saito_price);
      var usd_price = 0;
      if (ticker) {
        if (this.mixin_mod) {
          var _iterator2 = _createForOfIteratorHelper(this.mixin_mod.crypto_mods),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var cm = _step2.value;
              if (cm.ticker == ticker) {
                usd_price = Number(cm.price_usd);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        } else {
          var _iterator3 = _createForOfIteratorHelper(this.available_currencies),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _cm = _step3.value;
              if (_cm.ticker == ticker) {
                usd_price = Number(_cm.price_usd);
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      }
      if (usd_price == 0) {
        console.warn('BUYSAITO - No ticker selected for conversion!');
      }

      // calculate
      var amount_of_saito = amount * usd_price / saito_price;
      return Math.floor(amount_of_saito);
    }

    //
    // Check what mixin-supported web3 cryptos are on the service node
    //
  }, {
    key: "loadAvailableCryptos",
    value: function loadAvailableCryptos() {
      if (!this.mixin_mod) {
        console.error('BUYSAITO - No mixin module -- loadAvailableCryptos');
        return;
      }
      this.available_currencies = [];
      var _iterator4 = _createForOfIteratorHelper(this.mixin_mod.crypto_mods),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var cm = _step4.value;
          if (cm.ticker === 'ERC-SAITO') {
            if (!this.erc_saito) {
              this.erc_saito = cm;
              this.erc_saito.activate();
            }
          } else if (isAvailablePaymentCurrency(cm)) {
            this.available_currencies.push({
              ticker: cm.ticker,
              chain_id: cm.chain_id,
              price_usd: cm.price_usd,
              last_update: cm.last_update,
              icon_url: cm.icon_url
            });
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }

    //
    // Refresh USD-pair price info of Web3Cryptos
    //
  }, {
    key: "checkPrices",
    value: function () {
      var _checkPrices = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var updated, _iterator5, _step5, cm, _t3;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              updated = false;
              _iterator5 = _createForOfIteratorHelper(this.mixin_mod.crypto_mods);
              _context8.p = 1;
              _iterator5.s();
            case 2:
              if ((_step5 = _iterator5.n()).done) {
                _context8.n = 4;
                break;
              }
              cm = _step5.value;
              if (!(!cm.last_update || Date.now() - cm.last_update > 300000)) {
                _context8.n = 3;
                break;
              }
              updated = true;
              _context8.n = 3;
              return cm.returnMixinNetworkInfo();
            case 3:
              _context8.n = 2;
              break;
            case 4:
              _context8.n = 6;
              break;
            case 5:
              _context8.p = 5;
              _t3 = _context8.v;
              _iterator5.e(_t3);
            case 6:
              _context8.p = 6;
              _iterator5.f();
              return _context8.f(6);
            case 7:
              if (updated) {
                this.loadAvailableCryptos();
              }
            case 8:
              return _context8.a(2);
          }
        }, _callee8, this, [[1, 5, 6, 7]]);
      }));
      function checkPrices() {
        return _checkPrices.apply(this, arguments);
      }
      return checkPrices;
    }()
    /****************************************************************************************************
     * BuySaito uses the built-in Mixin functionality to support a *main* Mixin account, but in order
     * to have multiple valid deposit address, the node needs to juggle multiple mixin account credentials,
     * these are stored in a dedicated database and restored in the initialize() function
     *
     */
  }, {
    key: "createNewAltAccount",
    value: function () {
      var _createNewAltAccount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var res, sql, params;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              if (this.mixin_mod) {
                _context9.n = 1;
                break;
              }
              throw new Error('Mixin not installed');
            case 1:
              _context9.n = 2;
              return this.mixin_mod.createAccount(null, true);
            case 2:
              res = _context9.v;
              if (!(res !== null && res !== void 0 && res.err || !(res !== null && res !== void 0 && res.keys))) {
                _context9.n = 3;
                break;
              }
              throw new Error((res === null || res === void 0 ? void 0 : res.err) || 'Mixin alternate account was not created');
            case 3:
              // Save encrypted Mixin account (keys) in our own DB...
              sql = "INSERT INTO mixin_accounts (publickey, mixin_json) VALUES ($publickey, $mixin_json) ";
              params = {
                $publickey: this.publicKey,
                $mixin_json: res.res
              };
              _context9.n = 4;
              return this.app.storage.runDatabase(sql, params, 'buysaito');
            case 4:
              // Add raw account keys to our accounts array...
              this.mixin_accounts.push(res.keys);
              return _context9.a(2, res.keys);
          }
        }, _callee9, this);
      }));
      function createNewAltAccount() {
        return _createNewAltAccount.apply(this, arguments);
      }
      return createNewAltAccount;
    }()
  }, {
    key: "loadAltAccounts",
    value: function () {
      var _loadAltAccounts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var sql, params, res, privateKey, _iterator6, _step6, r, buf1, buf2;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              sql = "SELECT * FROM mixin_accounts WHERE publickey = $publickey";
              params = {
                $publickey: this.publicKey
              };
              _context0.n = 1;
              return this.app.storage.queryDatabase(sql, params, 'buysaito');
            case 1:
              res = _context0.v;
              _context0.n = 2;
              return this.app.wallet.getPrivateKey();
            case 2:
              privateKey = _context0.v;
              _iterator6 = _createForOfIteratorHelper(res);
              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  r = _step6.value;
                  // Unencrypt
                  buf1 = Buffer.from(r.mixin_json, 'base64');
                  buf2 = this.app.crypto.decryptWithPrivateKey(buf1, privateKey);
                  this.mixin_accounts.push(JSON.parse(buf2.toString('utf8')));
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
              console.info("BUYSAITO - Service Loaded ".concat(this.mixin_accounts.length, " alternate Mixin accounts"));
            case 3:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function loadAltAccounts() {
        return _loadAltAccounts.apply(this, arguments);
      }
      return loadAltAccounts;
    }()
  }, {
    key: "returnMixinAccountByID",
    value: function returnMixinAccountByID(user_id) {
      if (user_id == this.mixin_mod.mixin.user_id) {
        return this.mixin_mod.mixin;
      }
      for (var j = 0; j < this.mixin_accounts.length; j++) {
        if (this.mixin_accounts[j].user_id == user_id) {
          return this.mixin_accounts[j];
        }
      }
      console.error('Mixin account not found: ', user_id);
      return null;
    }

    //
    // Is this deposit address currently "busy", i.e. associated with a pending payment
    ///
  }, {
    key: "checkAvailability",
    value: function checkAvailability(ticker, destination) {
      if (!ticker || !destination) {
        return false;
      }
      var _iterator7 = _createForOfIteratorHelper(this.pending_payments),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var ep = _step7.value;
          if (ep.ticker == ticker && ep.destination == destination) {
            return false;
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      console.info(ticker + ':' + destination + ' available!');
      return true;
    }

    //
    //  Find or create a deposit address (Mixin account) that is not currently busy,
    //  then pass that accound and all the user provided data into the function to
    //  create the pending payment
    //
    //  payment_data : { publicKey, issue_amount, ticker, tx}
    //
  }, {
    key: "findAvailableAddress",
    value: function () {
      var _findAvailableAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(payment_data) {
        var cm, activated, ticker, destination, _iterator8, _step8, m, keys, _t4;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              if (this.mixin_mod) {
                _context1.n = 1;
                break;
              }
              throw new Error('Mixin payment service is unavailable');
            case 1:
              if (isAvailablePaymentCurrency(payment_data)) {
                _context1.n = 2;
                break;
              }
              throw new Error("Unsupported payment ticker: ".concat(payment_data === null || payment_data === void 0 ? void 0 : payment_data.ticker));
            case 2:
              //Is my main available?
              cm = this.app.wallet.returnCryptoModuleByTicker(payment_data.ticker);
              if (cm) {
                _context1.n = 3;
                break;
              }
              throw new Error("Unsupported payment ticker: ".concat(payment_data.ticker));
            case 3:
              _context1.n = 4;
              return cm.activate();
            case 4:
              activated = _context1.v;
              if (!(activated === false || !cm.address)) {
                _context1.n = 5;
                break;
              }
              throw new Error("Unable to create a ".concat(payment_data.ticker, " deposit address"));
            case 5:
              ticker = payment_data.ticker;
              destination = cm.address;
              if (!this.checkAvailability(ticker, destination)) {
                _context1.n = 7;
                break;
              }
              _context1.n = 6;
              return this.createPendingPayment(destination, payment_data, this.mixin_mod.mixin);
            case 6:
              return _context1.a(2);
            case 7:
              _iterator8 = _createForOfIteratorHelper(this.mixin_accounts);
              _context1.p = 8;
              _iterator8.s();
            case 9:
              if ((_step8 = _iterator8.n()).done) {
                _context1.n = 13;
                break;
              }
              m = _step8.value;
              _context1.n = 10;
              return this.mixin_mod.createDepositAddress(null, cm.chain_id, m);
            case 10:
              destination = _context1.v;
              if (!(destination && this.checkAvailability(ticker, destination))) {
                _context1.n = 12;
                break;
              }
              _context1.n = 11;
              return this.createPendingPayment(destination, payment_data, m);
            case 11:
              return _context1.a(2);
            case 12:
              _context1.n = 9;
              break;
            case 13:
              _context1.n = 15;
              break;
            case 14:
              _context1.p = 14;
              _t4 = _context1.v;
              _iterator8.e(_t4);
            case 15:
              _context1.p = 15;
              _iterator8.f();
              return _context1.f(15);
            case 16:
              console.info('BUYSAITO - Creating New Alt Account for Payment Processing...');
              _context1.n = 17;
              return this.createNewAltAccount();
            case 17:
              keys = _context1.v;
              _context1.n = 18;
              return this.mixin_mod.createDepositAddress(null, cm.chain_id, keys);
            case 18:
              destination = _context1.v;
              if (destination) {
                _context1.n = 19;
                break;
              }
              throw new Error("Unable to create an alternate ".concat(ticker, " deposit address"));
            case 19:
              _context1.n = 20;
              return this.createPendingPayment(destination, payment_data, keys);
            case 20:
              return _context1.a(2);
          }
        }, _callee1, this, [[8, 14, 15, 16]]);
      }));
      function findAvailableAddress(_x9) {
        return _findAvailableAddress.apply(this, arguments);
      }
      return findAvailableAddress;
    }() //
    // Restore DB-backed up pending payments in case server blips offline
    //
  }, {
    key: "loadPendingPayments",
    value: function () {
      var _loadPendingPayments = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var sql, params, res, now, expired_cutoff, i, pp;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              sql = "SELECT * FROM purchases WHERE active = 1";
              params = {};
              _context10.n = 1;
              return this.app.storage.queryDatabase(sql, params, 'buysaito');
            case 1:
              res = _context10.v;
              now = Date.now();
              expired_cutoff = now - this.time_limit;
              for (i = 0; i < res.length; i++) {
                if (res[i].created_at < expired_cutoff && res[i].status == 'new') {
                  this.cancelPayment(res[i].id);
                } else {
                  pp = Object.assign({}, res[i]);
                  pp.ts = pp.created_at;
                  delete pp.created_at;
                  delete pp.updated_at;
                  pp.mixin = this.returnMixinAccountByID(pp.mixin_user_id);
                  delete pp.mixin_user_id;
                  this.pending_payments.push(pp);
                }
              }
              _context10.n = 2;
              return this.reconcileIssuedPayments();
            case 2:
              this.clearInactivePayments();
              console.debug("BUYSAITO - Recovered ".concat(this.pending_payments.length, " pending payments from the DB"));
            case 3:
              return _context10.a(2);
          }
        }, _callee10, this);
      }));
      function loadPendingPayments() {
        return _loadPendingPayments.apply(this, arguments);
      }
      return loadPendingPayments;
    }() // Check if a user has a pending payment request
    // (so that we can restore that rather than generate a new one)
  }, {
    key: "hasPendingPayment",
    value: function hasPendingPayment(publicKey, ticker) {
      this.clearInactivePayments();

      // Check if this user has a pending payment and send them that info again
      var _iterator9 = _createForOfIteratorHelper(this.pending_payments),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var p = _step9.value;
          if (p.initiator_pubkey == publicKey && (!ticker || p.ticker === ticker)) {
            this.app.connection.emit('relay-send-message', {
              recipient: publicKey,
              request: 'buysaito reserve address',
              data: {
                id: p.id,
                initiator_pubkey: p.initiator_pubkey,
                issue_amount: p.issue_amount,
                ticker: p.ticker,
                destination: p.destination,
                mixin_id: p.mixin.user_id,
                expected_deposit: p.expected_deposit,
                reserved_until: p.ts + this.time_limit,
                status: p.paid ? 'issuing' : p.status
              }
            });
            return true;
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      return false;
    }

    //
    // Clean up array of pending payments to remove expired, cancelled, and completed payments
    //
  }, {
    key: "clearInactivePayments",
    value: function clearInactivePayments() {
      // Check for expired addresses
      var _iterator0 = _createForOfIteratorHelper(this.pending_payments),
        _step0;
      try {
        for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
          var pp = _step0.value;
          if (pp.status == 'new') {
            if (pp.ts + this.time_limit < Date.now()) {
              console.info('Marking payment as timed out');
              pp.status = 'failed';
              this.cancelPayment(pp.id);
            }
          }
        }

        // Clear from list
      } catch (err) {
        _iterator0.e(err);
      } finally {
        _iterator0.f();
      }
      for (var i = this.pending_payments.length - 1; i >= 0; i--) {
        if (this.pending_payments[i].status == 'cancelled' || this.pending_payments[i].status == 'failed' || Number(this.pending_payments[i].active) === 0) {
          this.pending_payments.splice(i, 1);
        }
      }
    }

    //
    // Pending payments are stored in an array and backed up in a database
    //
  }, {
    key: "createPendingPayment",
    value: function () {
      var _createPendingPayment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(destination, payment_data, mixin_account) {
        var sql, params, res;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              if (!(!destination || !(mixin_account !== null && mixin_account !== void 0 && mixin_account.user_id))) {
                _context11.n = 1;
                break;
              }
              throw new Error('Cannot reserve an incomplete Mixin payment address');
            case 1:
              // Add remaining fields
              payment_data.destination = destination;
              payment_data.ts = Date.now();
              payment_data.status = 'new';
              payment_data.mixin = mixin_account;

              // Do the math
              if (!payment_data.issue_amount) {
                _context11.n = 2;
                break;
              }
              payment_data.expected_deposit = this.convertSaitoToOther(payment_data.issue_amount, payment_data.ticker);
              _context11.n = 4;
              break;
            case 2:
              if (!payment_data.expected_deposit) {
                _context11.n = 3;
                break;
              }
              payment_data.issue_amount = this.convertToSaito(payment_data.expected_deposit, payment_data.ticker);
              _context11.n = 4;
              break;
            case 3:
              throw new Error('BuySaito: no valid numeric input');
            case 4:
              if (!(!Number.isFinite(Number(payment_data.issue_amount)) || Number(payment_data.issue_amount) <= 0 || !Number.isFinite(Number(payment_data.expected_deposit)) || Number(payment_data.expected_deposit) <= 0)) {
                _context11.n = 5;
                break;
              }
              throw new Error('BuySaito: invalid payment amount');
            case 5:
              // back up to DB
              sql = "INSERT INTO purchases (initiator_pubkey, recipient_pubkey, ticker, mixin_user_id, destination, issue_amount, expected_deposit, status, tx, created_at) \n    VALUES ($initiator_pubkey, $recipient_pubkey, $ticker, $mixin_user_id, $destination, $issue_amount, $expected_deposit, $status, $tx, $created_at)";
              params = {
                $initiator_pubkey: payment_data.initiator_pubkey,
                $recipient_pubkey: payment_data.recipient_pubkey,
                $ticker: payment_data.ticker,
                $mixin_user_id: mixin_account.user_id,
                $destination: payment_data.destination,
                $issue_amount: payment_data.issue_amount,
                $expected_deposit: payment_data.expected_deposit,
                $status: payment_data.status,
                $tx: payment_data.tx,
                $created_at: payment_data.ts
              };
              _context11.n = 6;
              return this.app.storage.runDatabase(sql, params, 'buysaito');
            case 6:
              res = _context11.v;
              console.debug('BUYSAITO - Saved new pending payment: ', res);
              if (res !== null && res !== void 0 && res.lastID) {
                payment_data.id = res.lastID;
              }
              this.pending_payments.push(payment_data);

              // Only return instructions after their reservation has been persisted.
              this.app.connection.emit('relay-send-message', {
                recipient: payment_data.initiator_pubkey,
                request: 'buysaito reserve address',
                data: {
                  id: payment_data.id,
                  status: payment_data.status,
                  initiator_pubkey: payment_data.initiator_pubkey,
                  recipient_pubkey: payment_data.recipient_pubkey,
                  issue_amount: payment_data.issue_amount,
                  ticker: payment_data.ticker,
                  destination: payment_data.destination,
                  mixin_id: payment_data.mixin.user_id,
                  expected_deposit: payment_data.expected_deposit,
                  reserved_until: payment_data.ts + this.time_limit
                }
              });
              console.debug(this.pending_payments);
            case 7:
              return _context11.a(2);
          }
        }, _callee11, this);
      }));
      function createPendingPayment(_x0, _x1, _x10) {
        return _createPendingPayment.apply(this, arguments);
      }
      return createPendingPayment;
    }()
    /*************************************************
     * 
     * Pending payments have a number of statuses
     * 
       Statuses: 
          'new'     -- user has requested a deposit address
          'pending'   -- payment is pending in Mixin account, cleared to issue saito
          'confirmed' -- payment in Mixin received (and transfered to safe wallet)
        'failed'    -- payment didn't come in...
          'cancelled' -- timeout or user cancels
     * 
     * The following utility functions update the DB with these statuses
     * 
     *************************************************/
    // We have evidence that mixin is going to get paid, so we mark as pending
    // (which means we can go ahead and release the SAITO)
  }, {
    key: "authorizePaymentIssuance",
    value: function () {
      var _authorizePaymentIssuance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(payment_data) {
        var sql, params;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              console.info('Mark payment as pending...');
              payment_data.status = 'pending';
              sql = "UPDATE purchases SET status = \"pending\", updated_at = $updated_at WHERE id=$id";
              params = {
                $id: payment_data.id,
                $updated_at: Date.now()
              };
              _context12.n = 1;
              return this.app.storage.runDatabase(sql, params, 'buysaito');
            case 1:
              this.notifyPaymentDetected(payment_data);
            case 2:
              return _context12.a(2);
          }
        }, _callee12, this);
      }));
      function authorizePaymentIssuance(_x11) {
        return _authorizePaymentIssuance.apply(this, arguments);
      }
      return authorizePaymentIssuance;
    }()
  }, {
    key: "confirmPaymentReceipt",
    value: function () {
      var _confirmPaymentReceipt = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(payment_data) {
        var sql, params;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              payment_data.status = 'confirmed';
              sql = "UPDATE purchases SET status = \"confirmed\", external_address = $external_address, updated_at = $updated_at WHERE id=$id";
              params = {
                $id: payment_data.id,
                $external_address: payment_data.external_address || '',
                $updated_at: Date.now()
              };
              _context13.n = 1;
              return this.app.storage.runDatabase(sql, params, 'buysaito');
            case 1:
              this.notifyPaymentDetected(payment_data);
            case 2:
              return _context13.a(2);
          }
        }, _callee13, this);
      }));
      function confirmPaymentReceipt(_x12) {
        return _confirmPaymentReceipt.apply(this, arguments);
      }
      return confirmPaymentReceipt;
    }()
  }, {
    key: "notifyPaymentDetected",
    value: function notifyPaymentDetected(payment) {
      // Send only public progress fields; payment.mixin contains account credentials.
      this.app.connection.emit('relay-send-message', {
        recipient: payment.initiator_pubkey,
        request: 'buysaito payment detected',
        data: {
          id: payment.id,
          ticker: payment.ticker,
          destination: payment.destination,
          status: payment.status
        }
      });
    }

    // Payment status is set as 'canceled' or 'failed' before calling the function
  }, {
    key: "cancelPayment",
    value: function () {
      var _cancelPayment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(payment_id) {
        var sql, params;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              console.log('Canceling payment');
              sql = "UPDATE purchases SET active = 0, status = \"failed\", updated_at = $updated_at WHERE id=$id";
              params = {
                $id: payment_id,
                $updated_at: Date.now()
              };
              _context14.n = 1;
              return this.app.storage.runDatabase(sql, params, 'buysaito');
            case 1:
              this.clearInactivePayments();
            case 2:
              return _context14.a(2);
          }
        }, _callee14, this);
      }));
      function cancelPayment(_x13) {
        return _cancelPayment.apply(this, arguments);
      }
      return cancelPayment;
    }()
  }, {
    key: "ensurePurchasesSchema",
    value: function () {
      var _ensurePurchasesSchema = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
        var columns, columnNames, additions, _i, _additions, _additions$_i, name, definition;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              _context15.n = 1;
              return this.app.storage.queryDatabase('PRAGMA table_info(purchases)', {}, 'buysaito');
            case 1:
              columns = _context15.v;
              columnNames = new Set(columns.map(function (column) {
                return column.name;
              }));
              additions = [['issuance_tx', "TEXT DEFAULT ''"], ['issuance_at', 'INTEGER DEFAULT 0'], ['issuance_block_id', 'INTEGER DEFAULT 0'], ['issuance_block_hash', "TEXT DEFAULT ''"]];
              _i = 0, _additions = additions;
            case 2:
              if (!(_i < _additions.length)) {
                _context15.n = 4;
                break;
              }
              _additions$_i = _slicedToArray(_additions[_i], 2), name = _additions$_i[0], definition = _additions$_i[1];
              if (columnNames.has(name)) {
                _context15.n = 3;
                break;
              }
              _context15.n = 3;
              return this.app.storage.runDatabase("ALTER TABLE purchases ADD COLUMN ".concat(name, " ").concat(definition), {}, 'buysaito');
            case 3:
              _i++;
              _context15.n = 2;
              break;
            case 4:
              return _context15.a(2);
          }
        }, _callee15, this);
      }));
      function ensurePurchasesSchema() {
        return _ensurePurchasesSchema.apply(this, arguments);
      }
      return ensurePurchasesSchema;
    }()
  }, {
    key: "recordPaymentIssuance",
    value: function () {
      var _recordPaymentIssuance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(payment_data, tx) {
        var issuanceAt, serializedTx, sql, params, result;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.n) {
            case 0:
              issuanceAt = Date.now();
              serializedTx = tx.serialize_to_web(this.app);
              sql = "UPDATE purchases\n      SET paid = $paid, issuance_tx = $issuance_tx, issuance_at = $issuance_at,\n          updated_at = $updated_at\n      WHERE id = $id AND active = 1 AND (paid = '' OR paid = $paid)";
              params = {
                $id: payment_data.id,
                $paid: tx.signature,
                $issuance_tx: serializedTx,
                $issuance_at: issuanceAt,
                $updated_at: issuanceAt
              };
              _context16.n = 1;
              return this.app.storage.runDatabase(sql, params, 'buysaito');
            case 1:
              result = _context16.v;
              if (!((result === null || result === void 0 ? void 0 : result.changes) === 0)) {
                _context16.n = 2;
                break;
              }
              throw new Error("BuySaito payment ".concat(payment_data.id, " is no longer available for issuance"));
            case 2:
              payment_data.paid = tx.signature;
              payment_data.issuance_tx = serializedTx;
              payment_data.issuance_at = issuanceAt;
            case 3:
              return _context16.a(2);
          }
        }, _callee16, this);
      }));
      function recordPaymentIssuance(_x14, _x15) {
        return _recordPaymentIssuance.apply(this, arguments);
      }
      return recordPaymentIssuance;
    }()
  }, {
    key: "rebroadcastPaymentIssuance",
    value: function () {
      var _rebroadcastPaymentIssuance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(payment_data) {
        var tx;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              if (payment_data.issuance_tx) {
                _context17.n = 1;
                break;
              }
              if (!payment_data.missing_issuance_notified) {
                console.error("BUYSAITO - Payment ".concat(payment_data.id, " has signature ").concat(payment_data.paid, " but no saved issuance transaction; manual review required"));
                payment_data.missing_issuance_notified = true;
              }
              return _context17.a(2);
            case 1:
              tx = new Transaction();
              tx.deserialize_from_web(this.app, payment_data.issuance_tx);
              if (!(!tx.signature || tx.signature !== payment_data.paid)) {
                _context17.n = 2;
                break;
              }
              throw new Error("BuySaito payment ".concat(payment_data.id, " has invalid saved issuance data"));
            case 2:
              _context17.n = 3;
              return this.app.wallet.addTransactionToPending(tx, false);
            case 3:
              _context17.n = 4;
              return this.app.network.propagateTransaction(tx);
            case 4:
              return _context17.a(2);
          }
        }, _callee17, this);
      }));
      function rebroadcastPaymentIssuance(_x16) {
        return _rebroadcastPaymentIssuance.apply(this, arguments);
      }
      return rebroadcastPaymentIssuance;
    }()
  }, {
    key: "confirmIssuedPaymentsInBlock",
    value: function () {
      var _confirmIssuedPaymentsInBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(blk, lc) {
        var signatures, _iterator1, _step1, payment, _t5;
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.p = _context18.n) {
            case 0:
              if (!(!lc || !Array.isArray(blk === null || blk === void 0 ? void 0 : blk.transactions) || !blk.transactions.length)) {
                _context18.n = 1;
                break;
              }
              return _context18.a(2);
            case 1:
              signatures = new Set(blk.transactions.map(function (tx) {
                return tx === null || tx === void 0 ? void 0 : tx.signature;
              }).filter(function (signature) {
                return signature;
              }));
              _iterator1 = _createForOfIteratorHelper(this.pending_payments);
              _context18.p = 2;
              _iterator1.s();
            case 3:
              if ((_step1 = _iterator1.n()).done) {
                _context18.n = 5;
                break;
              }
              payment = _step1.value;
              if (!(payment.paid && signatures.has(payment.paid))) {
                _context18.n = 4;
                break;
              }
              _context18.n = 4;
              return this.finishPayment(payment, blk);
            case 4:
              _context18.n = 3;
              break;
            case 5:
              _context18.n = 7;
              break;
            case 6:
              _context18.p = 6;
              _t5 = _context18.v;
              _iterator1.e(_t5);
            case 7:
              _context18.p = 7;
              _iterator1.f();
              return _context18.f(7);
            case 8:
              return _context18.a(2);
          }
        }, _callee18, this, [[2, 6, 7, 8]]);
      }));
      function confirmIssuedPaymentsInBlock(_x17, _x18) {
        return _confirmIssuedPaymentsInBlock.apply(this, arguments);
      }
      return confirmIssuedPaymentsInBlock;
    }()
  }, {
    key: "reconcileIssuedPayments",
    value: function () {
      var _reconcileIssuedPayments = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19() {
        var _this$app;
        var issued, blockchain, bySignature, earliestIssuance, latestId, id, hash, block, _iterator10, _step10, tx, payment, _t6, _t7, _t8;
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.p = _context19.n) {
            case 0:
              issued = this.pending_payments.filter(function (payment) {
                return payment.paid && payment.issuance_tx && Number(payment.issuance_at) > 0;
              });
              blockchain = (_this$app = this.app) === null || _this$app === void 0 ? void 0 : _this$app.blockchain;
              if (!(!issued.length || !(blockchain !== null && blockchain !== void 0 && blockchain.getLatestBlockId))) {
                _context19.n = 1;
                break;
              }
              return _context19.a(2);
            case 1:
              bySignature = new Map(issued.map(function (payment) {
                return [payment.paid, payment];
              }));
              earliestIssuance = Math.min.apply(Math, _toConsumableArray(issued.map(function (payment) {
                return Number(payment.issuance_at);
              })));
              _t6 = Number;
              _context19.n = 2;
              return blockchain.getLatestBlockId();
            case 2:
              latestId = _t6(_context19.v);
              id = latestId;
            case 3:
              if (!(id > 0 && bySignature.size)) {
                _context19.n = 22;
                break;
              }
              hash = '';
              block = null;
              _context19.p = 4;
              _context19.n = 5;
              return blockchain.getLongestChainHashAtId(id);
            case 5:
              hash = _context19.v;
              if (hash) {
                _context19.n = 6;
                break;
              }
              return _context19.a(3, 21);
            case 6:
              _context19.n = 7;
              return blockchain.loadBlockAsync(String(hash));
            case 7:
              block = _context19.v;
              if (block) {
                _context19.n = 9;
                break;
              }
              _context19.n = 8;
              return blockchain.getBlock(String(hash), true);
            case 8:
              block = _context19.v;
            case 9:
              _context19.n = 11;
              break;
            case 10:
              _context19.p = 10;
              _t7 = _context19.v;
              return _context19.a(3, 21);
            case 11:
              if (block) {
                _context19.n = 12;
                break;
              }
              return _context19.a(3, 21);
            case 12:
              _iterator10 = _createForOfIteratorHelper(block.transactions || []);
              _context19.p = 13;
              _iterator10.s();
            case 14:
              if ((_step10 = _iterator10.n()).done) {
                _context19.n = 17;
                break;
              }
              tx = _step10.value;
              payment = bySignature.get(tx === null || tx === void 0 ? void 0 : tx.signature);
              if (!payment) {
                _context19.n = 16;
                break;
              }
              _context19.n = 15;
              return this.finishPayment(payment, block);
            case 15:
              bySignature["delete"](tx.signature);
            case 16:
              _context19.n = 14;
              break;
            case 17:
              _context19.n = 19;
              break;
            case 18:
              _context19.p = 18;
              _t8 = _context19.v;
              _iterator10.e(_t8);
            case 19:
              _context19.p = 19;
              _iterator10.f();
              return _context19.f(19);
            case 20:
              if (!(Number(block.timestamp) < earliestIssuance)) {
                _context19.n = 21;
                break;
              }
              return _context19.a(3, 22);
            case 21:
              id--;
              _context19.n = 3;
              break;
            case 22:
              return _context19.a(2);
          }
        }, _callee19, this, [[13, 18, 19, 20], [4, 10]]);
      }));
      function reconcileIssuedPayments() {
        return _reconcileIssuedPayments.apply(this, arguments);
      }
      return reconcileIssuedPayments;
    }()
  }, {
    key: "finishPayment",
    value: function () {
      var _finishPayment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(payment_data, blk) {
        var sql, params, result;
        return _regenerator().w(function (_context20) {
          while (1) switch (_context20.n) {
            case 0:
              sql = "UPDATE purchases\n      SET active = 0, paid = $paid, issuance_block_id = $issuance_block_id,\n          issuance_block_hash = $issuance_block_hash, updated_at = $updated_at\n      WHERE id = $id AND active = 1 AND paid = $paid";
              params = {
                $id: payment_data.id,
                $paid: payment_data.paid,
                $issuance_block_id: Number((blk === null || blk === void 0 ? void 0 : blk.id) || 0),
                $issuance_block_hash: (blk === null || blk === void 0 ? void 0 : blk.hash) || '',
                $updated_at: Date.now()
              };
              _context20.n = 1;
              return this.app.storage.runDatabase(sql, params, 'buysaito');
            case 1:
              result = _context20.v;
              if (!((result === null || result === void 0 ? void 0 : result.changes) === 0)) {
                _context20.n = 2;
                break;
              }
              return _context20.a(2);
            case 2:
              payment_data.active = 0;
              payment_data.issuance_block_id = params.$issuance_block_id;
              payment_data.issuance_block_hash = params.$issuance_block_hash;
              this.app.connection.emit('relay-send-message', {
                recipient: payment_data.initiator_pubkey,
                request: 'buysaito saito issued',
                data: payment_data
              });
              console.debug('Payment done: ', payment_data);
              this.app.connection.emit('mailrelay-send-email', {
                to: 'buysaito@saito.tech',
                cc: 'richard@saito.tech',
                from: 'Saito Token Sales Bot <info@saito.tech>',
                subject: "On-Chain Saito Issued",
                text: JSON.stringify(payment_data, function (k, v) {
                  if (k == 'mixin') return undefined;else return v;
                }, 3),
                ishtml: false
              });
            case 3:
              return _context20.a(2);
          }
        }, _callee20, this);
      }));
      function finishPayment(_x19, _x20) {
        return _finishPayment.apply(this, arguments);
      }
      return finishPayment;
    }()
    /****************
     *
     * The main function loop that checks all pending payments,
     * the mixin deposit address and decides to issue SAITO
     *
     */
  }, {
    key: "processPendingPayments",
    value: function () {
      var _processPendingPayments2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21() {
        return _regenerator().w(function (_context21) {
          while (1) switch (_context21.p = _context21.n) {
            case 0:
              if (!this.processing_payments) {
                _context21.n = 1;
                break;
              }
              return _context21.a(2);
            case 1:
              this.processing_payments = true;
              _context21.p = 2;
              _context21.n = 3;
              return this._processPendingPayments();
            case 3:
              _context21.p = 3;
              this.processing_payments = false;
              return _context21.f(3);
            case 4:
              return _context21.a(2);
          }
        }, _callee21, this, [[2,, 3, 4]]);
      }));
      function processPendingPayments() {
        return _processPendingPayments2.apply(this, arguments);
      }
      return processPendingPayments;
    }()
  }, {
    key: "_processPendingPayments",
    value: function () {
      var _processPendingPayments3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23() {
        var _this4 = this;
        var _iterator11, _step11, payment, _iterator12, _step12, pp, success, lookup, _lookup, deposits, utxo, snapshots, cm, res, j, _j, _snapshots$_j$deposit, _iterator13, _step13, _loop, _ret, _t1, _t10, _t11, _t12, _t13, _t14;
        return _regenerator().w(function (_context24) {
          while (1) switch (_context24.p = _context24.n) {
            case 0:
              // First clear out any inactive payments
              this.clearInactivePayments();

              // Second, make sure we have something to process
              if (this.pending_payments.length) {
                _context24.n = 1;
                break;
              }
              return _context24.a(2);
            case 1:
              // A saved payout must not depend on Mixin being reachable again. Queue the
              // exact signed transaction first, then continue refreshing deposit status.
              _iterator11 = _createForOfIteratorHelper(this.pending_payments);
              _context24.p = 2;
              _iterator11.s();
            case 3:
              if ((_step11 = _iterator11.n()).done) {
                _context24.n = 8;
                break;
              }
              payment = _step11.value;
              // Refresh browser progress in case an earlier relay notification was missed.
              if (['pending', 'confirmed'].includes(payment.status)) {
                this.notifyPaymentDetected(payment);
              }
              if (!(payment.status !== 'new' && payment.paid)) {
                _context24.n = 7;
                break;
              }
              _context24.p = 4;
              _context24.n = 5;
              return this.rebroadcastPaymentIssuance(payment);
            case 5:
              _context24.n = 7;
              break;
            case 6:
              _context24.p = 6;
              _t1 = _context24.v;
              console.error("BUYSAITO - Failed to rebroadcast payment ".concat(payment.id, ":"), _t1);
            case 7:
              _context24.n = 3;
              break;
            case 8:
              _context24.n = 10;
              break;
            case 9:
              _context24.p = 9;
              _t10 = _context24.v;
              _iterator11.e(_t10);
            case 10:
              _context24.p = 10;
              _iterator11.f();
              return _context24.f(10);
            case 11:
              // Third, check Mixin to update status
              console.debug('BuySaito: Checking pending payments...');
              _iterator12 = _createForOfIteratorHelper(this.pending_payments);
              _context24.p = 12;
              _iterator12.s();
            case 13:
              if ((_step12 = _iterator12.n()).done) {
                _context24.n = 39;
                break;
              }
              pp = _step12.value;
              success = false;
              if (!(pp.status !== 'confirmed')) {
                _context24.n = 38;
                break;
              }
              lookup = void 0;
              _context24.p = 14;
              _context24.n = 15;
              return this.mixin_mod.consolidatedLookUp(pp.ticker, pp.destination, pp.ts,
              // only check recent transactions post creating the pending payment
              pp.mixin);
            case 15:
              lookup = _context24.v;
              _context24.n = 17;
              break;
            case 16:
              _context24.p = 16;
              _t11 = _context24.v;
              console.error("BUYSAITO - Deposit lookup failed for payment ".concat(pp.id, ":"), _t11.message);
              return _context24.a(3, 38);
            case 17:
              _lookup = lookup, deposits = _lookup.deposits, utxo = _lookup.utxo, snapshots = _lookup.snapshots;
              console.debug(pp.ticker, deposits, utxo, snapshots);

              ///////////////////////////
              // If we have a balance on an alternate account, mixin internal transfer to main
              // so the money is all under one set of keys
              _context24.p = 18;
              if (!(pp.mixin.user_id !== this.mixin_mod.mixin.user_id && Number(utxo) > 0)) {
                _context24.n = 20;
                break;
              }
              cm = this.app.wallet.returnCryptoModuleByTicker(pp.ticker);
              _context24.n = 19;
              return this.mixin_mod.sendInNetworkTransferRequest(cm.asset_id, this.mixin_mod.mixin.user_id, utxo, pp.mixin);
            case 19:
              res = _context24.v;
              console.debug('Mixin transfer between accounts: ', res);
            case 20:
              _context24.n = 22;
              break;
            case 21:
              _context24.p = 21;
              _t12 = _context24.v;
            case 22:
              j = 0;
            case 23:
              if (!(j < deposits.length)) {
                _context24.n = 30;
                break;
              }
              if (!(Number(deposits[j].amount) >= pp.expected_deposit)) {
                _context24.n = 28;
                break;
              }
              if (!(deposits[j].status == 'confirmed')) {
                _context24.n = 25;
                break;
              }
              _context24.n = 24;
              return this.confirmPaymentReceipt(pp);
            case 24:
              success = true;
              _context24.n = 27;
              break;
            case 25:
              if (!(pp.status == 'new')) {
                _context24.n = 27;
                break;
              }
              _context24.n = 26;
              return this.authorizePaymentIssuance(pp);
            case 26:
              success = true;
            case 27:
              _context24.n = 29;
              break;
            case 28:
              console.warn('Unexpected payment to mixin account...');
            case 29:
              j++;
              _context24.n = 23;
              break;
            case 30:
              if (success) {
                _context24.n = 35;
                break;
              }
              _j = 0;
            case 31:
              if (!(_j < snapshots.length)) {
                _context24.n = 35;
                break;
              }
              if (!(Number(snapshots[_j].amount) >= pp.expected_deposit)) {
                _context24.n = 33;
                break;
              }
              // Mark as confirmed
              pp.external_address = (_snapshots$_j$deposit = snapshots[_j].deposit) === null || _snapshots$_j$deposit === void 0 ? void 0 : _snapshots$_j$deposit.sender;
              _context24.n = 32;
              return this.confirmPaymentReceipt(pp);
            case 32:
              _context24.n = 34;
              break;
            case 33:
              console.warn('Unexpected payment to mixin account...');
            case 34:
              _j++;
              _context24.n = 31;
              break;
            case 35:
              if (!this.local_dev) {
                _context24.n = 38;
                break;
              }
              if (!(Math.random() > 0.5)) {
                _context24.n = 38;
                break;
              }
              console.debug('Local test mode: upgrading payment status...');
              if (!(pp.status == 'new')) {
                _context24.n = 37;
                break;
              }
              _context24.n = 36;
              return this.authorizePaymentIssuance(pp);
            case 36:
              _context24.n = 38;
              break;
            case 37:
              if (!(pp.status == 'pending')) {
                _context24.n = 38;
                break;
              }
              _context24.n = 38;
              return this.confirmPaymentReceipt(pp);
            case 38:
              _context24.n = 13;
              break;
            case 39:
              _context24.n = 41;
              break;
            case 40:
              _context24.p = 40;
              _t13 = _context24.v;
              _iterator12.e(_t13);
            case 41:
              _context24.p = 41;
              _iterator12.f();
              return _context24.f(41);
            case 42:
              // Fourth, issue payments
              _iterator13 = _createForOfIteratorHelper(this.pending_payments);
              _context24.p = 43;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var pp, available_nolan, required_nolan, pending_nolan, available_balance, _t9, _t0;
                return _regenerator().w(function (_context23) {
                  while (1) switch (_context23.p = _context23.n) {
                    case 0:
                      pp = _step13.value;
                      if (!(pp.status !== 'new' && !pp.paid)) {
                        _context23.n = 13;
                        break;
                      }
                      _context23.p = 1;
                      _context23.n = 2;
                      return _this4.app.wallet.getBalance();
                    case 2:
                      available_nolan = _context23.v;
                      required_nolan = _this4.app.wallet.convertSaitoToNolan(pp.issue_amount);
                      if (!(typeof available_nolan !== 'bigint' || typeof required_nolan !== 'bigint' || available_nolan < 0n || required_nolan <= 0n)) {
                        _context23.n = 3;
                        break;
                      }
                      throw new Error('Invalid payout balance or amount');
                    case 3:
                      _context23.n = 5;
                      break;
                    case 4:
                      _context23.p = 4;
                      _t9 = _context23.v;
                      console.error("BUYSAITO - Unable to check funding for payment ".concat(pp.id, ":"), _t9);
                      return _context23.a(2, 0);
                    case 5:
                      if (!(available_nolan >= required_nolan)) {
                        _context23.n = 7;
                        break;
                      }
                      _context23.n = 6;
                      return _this4.createSaitoIssuanceTransaction(pp).then(/*#__PURE__*/function () {
                        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(tx) {
                          return _regenerator().w(function (_context22) {
                            while (1) switch (_context22.n) {
                              case 0:
                                _context22.n = 1;
                                return _this4.recordPaymentIssuance(pp, tx);
                              case 1:
                                _context22.n = 2;
                                return _this4.app.wallet.addTransactionToPending(tx);
                              case 2:
                                _context22.n = 3;
                                return _this4.app.network.propagateTransaction(tx);
                              case 3:
                                return _context22.a(2);
                            }
                          }, _callee22);
                        }));
                        return function (_x21) {
                          return _ref3.apply(this, arguments);
                        };
                      }())["catch"](function (err) {
                        console.error("BUYSAITO - Issuance failed for payment ".concat(pp.id, ":"), err);
                        _this4.app.connection.emit('mailrelay-send-email', {
                          to: 'buysaito@saito.tech',
                          cc: 'richard@saito.tech',
                          from: 'Saito Token Sales Bot <info@saito.tech>',
                          subject: "ATTN: Saito Issuance Failure!!",
                          text: String(err)
                        });

                        // If this is just a matter of the node lacking slips,
                        // the pending payment (even one that is confirmed)
                        // will remain active and remain in the queue to be issued on the next new block
                        // If the server crashes, it will be restored from DB backup and added to the queue
                      });
                    case 6:
                      _context23.n = 13;
                      break;
                    case 7:
                      _context23.p = 7;
                      _context23.n = 8;
                      return _this4.app.core.wallet.getPendingBalance();
                    case 8:
                      pending_nolan = _context23.v;
                      if (!(typeof pending_nolan !== 'bigint' || pending_nolan < 0n)) {
                        _context23.n = 9;
                        break;
                      }
                      throw new Error('Invalid pending balance');
                    case 9:
                      if (!(pending_nolan >= required_nolan)) {
                        _context23.n = 10;
                        break;
                      }
                      return _context23.a(2, 0);
                    case 10:
                      _context23.n = 12;
                      break;
                    case 11:
                      _context23.p = 11;
                      _t0 = _context23.v;
                      console.error("BUYSAITO - Unable to confirm funding shortage for payment ".concat(pp.id, ":"), _t0);
                      return _context23.a(2, 0);
                    case 12:
                      if (!pp.notified) {
                        available_balance = _this4.app.wallet.convertNolanToSaito(available_nolan);
                        console.error('BuySaito cannot complete sale because lacking money: ', available_balance, pp.issue_amount);
                        _this4.app.connection.emit('mailrelay-send-email', {
                          to: 'buysaito@saito.tech',
                          cc: 'richard@saito.tech',
                          from: 'Saito Token Sales Bot <info@saito.tech>',
                          subject: "ATTN: Insufficient Funds to Complete Sale -- " + available_balance,
                          text: JSON.stringify(pp, function (k, v) {
                            if (k == 'mixin') return undefined;else return v;
                          }, 3),
                          ishtml: false
                        });
                        _this4.app.connection.emit('relay-send-message', {
                          recipient: pp.initiator_pubkey,
                          request: 'buysaito report error',
                          data: {
                            code: 'insufficient_funds',
                            id: pp.id,
                            ticker: pp.ticker,
                            destination: pp.destination
                          }
                        });
                        pp.notified = true;
                      }
                    case 13:
                      return _context23.a(2);
                  }
                }, _loop, null, [[7, 11], [1, 4]]);
              });
              _iterator13.s();
            case 44:
              if ((_step13 = _iterator13.n()).done) {
                _context24.n = 47;
                break;
              }
              return _context24.d(_regeneratorValues(_loop()), 45);
            case 45:
              _ret = _context24.v;
              if (!(_ret === 0)) {
                _context24.n = 46;
                break;
              }
              return _context24.a(3, 46);
            case 46:
              _context24.n = 44;
              break;
            case 47:
              _context24.n = 49;
              break;
            case 48:
              _context24.p = 48;
              _t14 = _context24.v;
              _iterator13.e(_t14);
            case 49:
              _context24.p = 49;
              _iterator13.f();
              return _context24.f(49);
            case 50:
              return _context24.a(2);
          }
        }, _callee23, this, [[43, 48, 49, 50], [18, 21], [14, 16], [12, 40, 41, 42], [4, 6], [2, 9, 10, 11]]);
      }));
      function _processPendingPayments() {
        return _processPendingPayments3.apply(this, arguments);
      }
      return _processPendingPayments;
    }()
  }, {
    key: "createSaitoIssuanceTransaction",
    value: function () {
      var _createSaitoIssuanceTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(payment_data) {
        var payment_recipient, txmsg, _txmsg, userTX, address, newtx, issuance_data;
        return _regenerator().w(function (_context25) {
          while (1) switch (_context25.n) {
            case 0:
              payment_recipient = payment_data.recipient_pubkey;
              txmsg = null;
              if (payment_data.tx) {
                userTX = new Transaction();
                userTX.deserialize_from_web(this.app, payment_data.tx);
                txmsg = userTX.returnMessage();
                if ((_txmsg = txmsg) !== null && _txmsg !== void 0 && _txmsg.p2sh_address) {
                  address = txmsg.p2sh_address;
                  payment_recipient = address.length === 66 && address.startsWith('00') ? this.app.crypto.toBase58(address) : address;
                }
              }
              _context25.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(payment_recipient, this.app.wallet.convertSaitoToNolan(payment_data.issue_amount));
            case 1:
              newtx = _context25.v;
              if (txmsg) {
                newtx.msg = txmsg;
              } else {
                // Wallet pending/propagation clones re-pack the transaction message. Keep
                // the signed data detached from the DB-backed payment object, which is
                // updated with issuance metadata immediately after signing. Mixin account
                // data contains private credentials and must never enter an on-chain tx.
                issuance_data = JSON.parse(JSON.stringify(payment_data, function (key, value) {
                  return key === 'mixin' ? undefined : value;
                }));
                newtx.msg = {
                  module: 'BuySaito',
                  request: 'buysaito issuance',
                  data: issuance_data,
                  memo: "".concat(payment_data.expected_deposit, " ").concat(payment_data.ticker)
                };
              }
              console.debug("Issuing ".concat(payment_data.issue_amount, " Saito to ").concat(payment_data.recipient_pubkey, " with tx_msg: "), newtx.msg);
              _context25.n = 2;
              return newtx.sign();
            case 2:
              return _context25.a(2, newtx);
          }
        }, _callee24, this);
      }));
      function createSaitoIssuanceTransaction(_x22) {
        return _createSaitoIssuanceTransaction.apply(this, arguments);
      }
      return createSaitoIssuanceTransaction;
    }()
  }]);
}(ModTemplate);
module.exports = BuySaito;